export { default } from "./updatePersonalInformationForm";
